import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { BrandKit } from 'types'
import { buildErrorMessage } from 'utils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { reportError } from 'utils/error'

interface Props {
  id: number
}

interface Data {
  brand_kit: BrandKit
}

interface Context {
  previousBrandKit?: BrandKit
}

export const updateImageDescriptions = async ({ id, workspaceId }: Props & { workspaceId: number }) => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/brand_kits/${id}/update_image_descriptions`, {
    method: 'POST',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to update image descriptions', {
      metaData: {
        id,
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useUpdateImageDescriptions = ({ id }: Props) => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useMutation<Data, Error, void, Context>(
    ['workspaces', currentWorkspaceId, 'brandKits', id, 'useUpdateImageDescriptions'],
    () => {
      return updateImageDescriptions({ id, workspaceId: currentWorkspaceId })
    },
  )
}
